import React from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { DESCRIPTION_MAX_LENGTH, type DetailsFormData, isHttpsUrl, NAME_MAX_LENGTH } from '../form/customIntegrationForm'

interface CustomIntegrationDetailsFormFieldsProps {
  data: DetailsFormData
  onChange: (data: DetailsFormData) => void
  className?: string
  descriptionRows?: number
}

export const CustomIntegrationDetailsFormFields: React.FC<CustomIntegrationDetailsFormFieldsProps> = ({ data, onChange, className, descriptionRows = 2 }) => {
  const update = (patch: Partial<DetailsFormData>) => onChange({ ...data, ...patch })
  const endpointUrl = data.endpointUrl.trim()
  const imageUrl = data.imageUrl.trim()

  return (
    <div className={classNames('d-flex flex-column gap-3', className)}>
      <Form.Group controlId='custom-integration-name'>
        <Form.Label className='paragraph-small mb-1'>Name</Form.Label>
        <Form.Control
          type='text'
          placeholder='e.g., My MCP Server'
          value={data.name}
          maxLength={NAME_MAX_LENGTH}
          onChange={(e) => update({ name: e.target.value })}
        />
        <Form.Text className='paragraph-extra-small zocks-text-gray-600'>Display name your MCP server will be represented on the Apps page.</Form.Text>
      </Form.Group>

      <Form.Group controlId='custom-integration-endpoint-url'>
        <Form.Label className='paragraph-small mb-1'>URL</Form.Label>
        <Form.Control
          type='url'
          placeholder='e.g. https://www.example.xyz/mcp'
          value={data.endpointUrl}
          isInvalid={endpointUrl !== '' && !isHttpsUrl(endpointUrl)}
          onChange={(e) => update({ endpointUrl: e.target.value })}
        />
        <Form.Control.Feedback type='invalid'>Please enter a valid HTTPS URL.</Form.Control.Feedback>
        <Form.Text className='paragraph-extra-small zocks-text-gray-600'>The HTTPS endpoint of your MCP server</Form.Text>
      </Form.Group>

      <Form.Group controlId='custom-integration-description'>
        <Form.Label className='paragraph-small mb-1'>
          Description <span className='zocks-text-gray-600'>(Optional)</span>
        </Form.Label>
        <Form.Control
          as='textarea'
          rows={descriptionRows}
          placeholder='e.g. Connect to our internal ticketing system'
          value={data.description}
          maxLength={DESCRIPTION_MAX_LENGTH}
          onChange={(e) => update({ description: e.target.value })}
        />
        <Form.Text className='paragraph-extra-small zocks-text-gray-600'>Describe what this MCP does</Form.Text>
      </Form.Group>

      <Form.Group controlId='custom-integration-image-url'>
        <Form.Label className='paragraph-small mb-1'>
          Icon URL <span className='zocks-text-gray-600'>(Optional)</span>
        </Form.Label>
        <Form.Control
          type='url'
          placeholder='https://...'
          value={data.imageUrl}
          isInvalid={imageUrl !== '' && !isHttpsUrl(imageUrl)}
          onChange={(e) => update({ imageUrl: e.target.value })}
        />
        <Form.Control.Feedback type='invalid'>Please enter a valid HTTPS URL.</Form.Control.Feedback>
        <Form.Text className='paragraph-extra-small zocks-text-gray-600'>
          An HTTPS link to an icon for your connection. Supported formats: PNG, SVG, JPG
        </Form.Text>
      </Form.Group>
    </div>
  )
}
